module.exports = __webpack_public_path__ + "img/img60.a9f881ec.png";